import {
    Box, makeStyles, styled as styledMaterial,
} from '@material-ui/core';
import { MainTheme } from '@paretogroup/tess';

export const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: MainTheme.colors.white,
        backgroundClip: 'padding-box',
        backgroundRepeat: 'no-repeat',
    },
    elementsContainer: {
        width: '263px',
    },
    title: {
        marginTop: '8px',
    },
    subtitle: {
        margin: '0 0 37px',
    },
    logo: {
        marginBottom: '0',
    },
    wrapper: {
        marginBottom: '8px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    label: {
        textAlign: 'center',
        margin: 'auto',
    },
}));

export const ROUNDED_BUTTON_STYLE = {
    background: `${MainTheme.colors['fun-green']} 0% 0% no-repeat padding-box`,
    fontSize: '16px',
    fontWeight: 400,
    height: '32px',
    minHeight: '32px',
    width: '100%',
};

export const Paragraph = styledMaterial(Box)({
    color: MainTheme.colors.white,
    font: '400 14px Helvetica, serif',
    marginBotton: '37px',
    '& a': {
        color: MainTheme.colors.white,
        cursor: 'pointer',
        textDecoration: 'underline',
        '&:hover': {
            color: MainTheme.colors.white,
        },
    },
});

export const TitleWrapper = styledMaterial(Box)({
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '32px',
    lineHeight: '37px',
    textAlign: 'center',
    color: MainTheme.colors.white,
});
